<div class="flex gap-2">
  <button
    class="bo-button-secondary flex items-center justify-center bg-white/20"
    (click)="previousPage(); previousClicked.emit()"
  >
    <svg-icon
      src="fa-icons/chevron-left.svg"
      class="fill-bo-primary"
      [svgStyle]="{ 'height.px': 20 }"
    />
  </button>
  <button
    class="bo-button flex min-w-48 items-center justify-between gap-2 px-3"
    (click)="nextPage(); nextClicked.emit()"
  >
    <div class="flex flex-1 justify-center px-3">{{ label() }}</div>
    <svg-icon
      src="fa-icons/chevron-right.svg"
      class="bo-subheader !fill-bo-white"
      [svgStyle]="{ 'height.px': 20 }"
    />
  </button>
</div>
